// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Qyb","labelIcon":"az_Ryb","wrapper":"az_Syb","textColorInherit":"az_Tyb","selected":"az_Uyb","disabled":"az_Vyb","fullWidth":"az_Wyb","noHoverStyle":"az_Xyb"};